// this file added by Bearer Web Developer
import React from 'react';
import { useThemeMode } from '../../states/contexts/theme';

const BearerHeaderLogo: React.FC = () => {
    const { theme } = useThemeMode();
    return (
        <>
            {theme === 'dark' ?
                <img src="/bearer-header-logo-with-text-dark.webp" alt="bearer" height={26} />
                : <img src="/bearer-header-logo-with-text.webp" alt="bearer" height={26} />
            }
        </>
    )
};
export default BearerHeaderLogo